import type {EBirdChecklistByFamily} from "ebird-mydata-reader";

export type SpeciesMetadataEntry = {
    taxonomicOrder: number,
    speciesCode: string,
    commonName: string,
    scientificName: string,
    speciesGroup?: string
}

export function buildSpeciesMetadataLookup(checklist: EBirdChecklistByFamily[]) {
    const speciesMetadataByTaxonomicOrder = new Map<number, SpeciesMetadataEntry>();

    for (const family of checklist) {
        const speciesGroup = family.familyCommon || family.familyName;

        for (const species of family.speciesList) {
            const entry: SpeciesMetadataEntry = {
                taxonomicOrder: species.taxonomicOrder,
                speciesCode: species.speciesCode,
                commonName: species.commonName,
                scientificName: species.scientificName,
                speciesGroup
            };

            speciesMetadataByTaxonomicOrder.set(species.taxonomicOrder, entry);

            for (const alternateTaxonomicOrder of species.alternateTaxonomicOrders ?? []) {
                speciesMetadataByTaxonomicOrder.set(alternateTaxonomicOrder, entry);
            }
        }
    }

    return (taxonomicOrder: number) => speciesMetadataByTaxonomicOrder.get(taxonomicOrder);
}

